import { executeFetch } from '../actions'
import { isEmpty } from 'lodash'
import moize from 'moize'

export const executeFetchWithMemo = (fetchFn) =>
  moize.promise(fetchFn, {
    isDeepEqual: true,
    maxAge: 300000,
    maxSize: 50
  })

export const fetchTableData = async (body, selectedStore) => {
  const queryParams = selectedStore?.id ? `?store=${selectedStore.id}` : ''
  const url = `/output/store-collaboration/user-feedback/table${queryParams}`

  try {
    return await executeFetch(url, body, 'POST')
  } catch (error) {
    return { items: [], metadata: { pagination: { total: 0 } } }
  }
}

export const fetchDetailTableData = async (filters) => {
  const { selectedRow, uom } = filters
  const params = new URLSearchParams()
  params.append('id', selectedRow?.id)
  params.append('unitofmeasure', uom)

  const url = `/output/store-collaboration/user-feedback/composition-table?${params.toString()}`

  try {
    return await executeFetch(url)
  } catch (error) {
    return { items: [], metadata: { pagination: { total: 0 } } }
  }
}

export const updateStatus = async (selectedStore, type, body) => {
  const queryParams = selectedStore?.id
    ? `store=${selectedStore.id}&type=${type}`
    : ''
  const url = `/output/store-collaboration/user-feedback/table/status?${queryParams}`

  try {
    return await executeFetch(url, body, 'PUT')
  } catch (error) {
    return error
  }
}

export const fetchInfoData = async (body) => {
  const { store: selectedStore, selectedRooms, allRooms, uom } = body
  const params = new URLSearchParams()
  params.append('store', selectedStore.id)
  params.append('unitofmeasure', uom)
  if (!isEmpty(selectedRooms)) {
    selectedRooms.forEach((room) => params.append('room', room.id))
  } else if (!isEmpty(allRooms)) {
    allRooms.forEach((room) => params.append('room', room.id))
  } else return []

  const url = `/output/store-collaboration/user-feedback/data?${params.toString()}`

  try {
    return await executeFetch(url)
  } catch (error) {
    return null
  }
}

export const fetchDetailInfoData = async (body) => {
  const { store: selectedStore, room, uom, id } = body
  const params = new URLSearchParams()
  params.append('store', selectedStore.id)
  params.append('id', id)
  params.append('unitofmeasure', uom)
  params.append('room', room)

  const url = `/output/store-collaboration/user-feedback/composition-kpis?${params.toString()}`

  try {
    return await executeFetch(url)
  } catch (error) {
    return null
  }
}

// export const fetchTableData = executeFetchWithMemo(_fetchTableData)
// export const fetchDetailTableData = executeFetchWithMemo(_fetchDetailTableData)
// export const fetchInfoData = executeFetchWithMemo(_fetchInfoData)
// export const fetchDetailInfoData = executeFetchWithMemo(_fetchDetailInfoData)
